import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWaveform } from "@fortawesome/pro-solid-svg-icons";
import { ReactNode } from "react";

interface BookingsScreenTabLabelTagProps {
  isLoading?: boolean;
  isError?: boolean;
  children?: ReactNode;
}

export const BookingsScreenTabLabelTag = ({
  isLoading,
  isError,
  children,
}: BookingsScreenTabLabelTagProps) => {
  return isLoading ? (
    <FontAwesomeIcon
      icon={faWaveform}
      size={"xs"}
      className={"fa-beat"}
      css={{
        ["--fa-beat-scale"]: "0.75",
      }}
    />
  ) : isError ? (
    "!"
  ) : (
    children
  );
};
